import TextInput from './TextInput';
import LinkableTextInput from './LinkableTextInput';

export { LinkableTextInput };

export default TextInput;
